import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export function useSafeAreaBottom({
  isInModal,
}: {
  isInModal: boolean;
}): number {
  const { bottom: safeAreaBottom } = useSafeAreaInsets();

  return !isInModal
    ? safeAreaBottom
    : Platform.OS === 'ios' && !Platform.isPad
      ? safeAreaBottom
      : 0;
}
